import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {authService} from "../../../services/auth.service";
import LoadingSpinner from "../../../components/common/LoadingSpinner";

const EntraCallback = () => {
    const navigate = useNavigate();

    // should work only once, after mounting, due to one-time code
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const code = queryParams.get('code');

        if (!code) {
            navigate('/login?error=no_code', { replace: true });
            return;
        }

        const fetchData = async () => {
            try {
                const response = await authService.exchangeEntraCode(code);

                authService.finalizeAuthentication(response, 'entraIdUFallbackUserName');
                navigate('/dashboard', { replace: true });
            } catch (err) {
                console.error(err);
                navigate('/login?error=auth_failed', { replace: true });
            }
        };

        void fetchData();
    }, []);

    return <LoadingSpinner />;
};

export default EntraCallback;